<template>
  <div class="dashboard-pages">
    <v-card class="pa-3">
      <v-layout row wrap justify-space-between>
        <dt-search-box
          :search="search"
          @typing="searchValue"
          @reset-datatable="resetDataTable()"
          @clear-search-field="search = null"
        />

        <v-layout row wrap justify-end class="pt-2 pb-2">
          <v-btn dark color="primary" v-if="hasPermissions(['purchases_store'])" @click="dialogs.addDialog = true">
            <v-icon>add</v-icon>
            {{ $t('datatable-add-new') }}
          </v-btn>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card flat>
      <v-layout row wrap justify-end>
        <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin: 5px 0px; height: 30px; width: 30px"
              :loading="loadThePrintBtn"
              flat
              fab
              v-on="on"
              color="primary"
              @click="getNoPaginatedData('print')"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`Print Table`) }}</span>
        </v-tooltip>
        <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin: 5px 20px 5px 10px; height: 30px; width: 30px"
              fab
              :loading="loadTheExportBtn"
              flat
              v-on="on"
              color="primary"
              @click="getNoPaginatedData('export')"
            >
              <v-icon>fa-file-excel</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`Export Table`) }}</span>
        </v-tooltip>
      </v-layout>
    </v-card>

    <v-card class="px-4 pb-4">
      <v-data-table
        v-show="isDatatable"
        :headers="headers"
        :items="resultData.data"
        :item-key="defaultSortBy"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="resultData.total"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.purchase_id }}</td>-->
          <td>{{ props.item.bill_auto_number }}</td>
          <td>{{ props.item.supplier_invoice_number }}</td>
          <td>{{ props.item.vender_name }}</td>
          <td>{{ props.item.grand_total_amount | currency }}</td>
          <td>{{ props.item.bill_date }}</td>
          <td>{{ props.item.cash_or_opening_balance }}</td>
          <td>
            <v-tooltip top>
              <v-chip
                slot="activator"
                label
                :color="props.item.bill_status === 'Open' ? 'error' : 'success'"
                text-color="white"
                class="no-select"
              >
                <v-icon>{{ props.item.bill_status === 'Open' ? 'fa-lock-open' : 'fa-lock' }}</v-icon>
              </v-chip>
              <span>{{ props.item.bill_status === 'Open' ? $t('Open') : $t('Close') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip top>
              <v-chip
                slot="activator"
                label
                :color="
                  props.item.payment_status === null && props.item.cash_or_opening_balance === 'Opening Balance'
                    ? 'primary'
                    : props.item.payment_status === 'Paid' || props.item.cash_or_opening_balance === 'Cash'
                    ? 'success'
                    : props.item.payment_status === 'Paid Partially'
                    ? 'warning'
                    : 'error'
                "
                text-color="white"
                class="no-select"
              >
                <v-icon>{{
                  props.item.payment_status === 'Paid' ||
                  props.item.payment_status === 'Paid Partially' ||
                  props.item.cash_or_opening_balance === 'Cash'
                    ? 'attach_money'
                    : props.item.payment_status === null && props.item.cash_or_opening_balance === 'Opening Balance'
                    ? 'monetization_on'
                    : 'money_off'
                }}</v-icon>
              </v-chip>
              <span>{{
                props.item.payment_status === 'Paid'
                  ? $t('Paid')
                  : props.item.payment_status === 'Paid Partially'
                  ? $t('Paid Partially')
                  : props.item.payment_status === null && props.item.cash_or_opening_balance === 'Opening Balance'
                  ? $t('Opening Balance')
                  : $t('Not Paid')
              }}</span>
            </v-tooltip>
          </td>
          <!-- <td
            v-if="hasActionsMenuPermissions()"
            style="position: sticky; right: 0;
              background-color: #FFFFFF;
              -webkit-box-shadow: 4px 10px 10px 1px #bbbbbb;
              -moz-box-shadow: 4px 10px 10px 1px #bbbbbb;
              box-shadow: 4px 10px 10px 1px #bbbbbb;
              z-index: 1
            "
          >-->
          <td v-if="hasActionsMenuPermissions()">
            <v-menu offset-y bottom :left="!$vuetify.rtl" :right="$vuetify.rtl" transition="slide-y-reverse-transition">
              <v-btn flat fab icon class="transparent py-2" slot="activator">
                <v-icon large class="grey--text actions-btn">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-tooltip v-if="hasPermissions(['purchases_show'])" :left="!$vuetify.rtl" :right="$vuetify.rtl">
                  <v-list-tile slot="activator" @click="viewRecord(props.item.purchase_id)">
                    <v-icon>chrome_reader_mode</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-view') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`View Purchase's information`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['purchases_update']) &&
                      (props.item.bill_status === 'Open' || props.item.cash_or_opening_balance === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="editRecord(props.item.purchase_id)">
                    <v-icon>edit</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-edit') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Edit Purchase's information`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['purchases_close']) &&
                      props.item.bill_status === 'Open' &&
                      props.item.cash_or_opening_balance !== 'Cash'
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="closePurchaseRecord(props.item)">
                    <v-icon>fa-lock</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('close-purchase') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Close Purchase`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['purchases_unclose']) &&
                      props.item.cash_or_opening_balance !== 'Cash' &&
                      props.item.bill_status === 'Close' &&
                      (props.item.payment_status === 'Not Paid' || props.item.payment_status === null)
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="openPurchaseRecord(props.item.purchase_id)">
                    <v-icon>fa-lock-open</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('open-purchase') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Open Purchase`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['single_statement_payment_store']) &&
                      props.item.bill_status === 'Close' &&
                      props.item.payment_status !== 'Paid' &&
                      props.item.cash_or_opening_balance !== 'Cash' &&
                      props.item.cash_or_opening_balance !== 'Opening Balance'
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="singlePayment(props.item)">
                    <v-icon>payment</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('Payment') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Add Payment For This Statement`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['purchase_return_store']) &&
                      (props.item.bill_status === 'Close' || props.item.cash_or_opening_balance === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="returnPurchaseRecord(props.item.purchase_id)">
                    <v-icon>fa-undo</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('return-purchase') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Return Purchase`) }}</span>
                </v-tooltip>

                <v-divider
                  v-if="
                    hasPermissions(['purchases_destroy']) &&
                      (props.item.bill_status === 'Open' || props.item.cash_or_opening_balance === 'Cash')
                  "
                />

                <v-tooltip
                  v-if="
                    hasPermissions(['purchases_destroy']) &&
                      (props.item.bill_status === 'Open' || props.item.cash_or_opening_balance === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="showConfirmDeletion(props.item.purchase_id)">
                    <v-icon class="red--text">delete</v-icon>
                    <v-list-tile-content class="red--text px-3">{{ $t('datatable-delete') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t('Delete Purchase Record') }}</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">{{
          $t('Sorry, No results found for your search criteria')
        }}</v-alert>
      </v-data-table>

      <dt-pagination
        :resultData="resultData"
        :pagination="pagination"
        :perPageNumber="perPageNumber"
        @page-changed="pageChanged"
        @per-page-changed="resultsPerPageChanged"
      />
    </v-card>

    <add-purchase
      :addDialog="dialogs.addDialog"
      @reset-datatable="resetDataTable(), resetAllErrors(true)"
      @hidemodal="resetAllErrors(true), (dialogs.addDialog = false)"
      @add-supplier="dialogs.addSupplier = true"
      @add-product="dialogs.addProduct = true"
    />

    <edit-purchase
      :editDialog="dialogs.editDialog"
      @updated="updateDatatableResult(), (dialogs.editDialog = false), (allowGettingData = false)"
      @hidemodal="resetAllErrors(true), (dialogs.editDialog = false)"
      @add-supplier="dialogs.addSupplier = true"
      @add-product="dialogs.addProduct = true"
    />

    <confirm-deletion
      :deleteDialog="dialogs.deleteDialog"
      :btnDeleteLoading="btnDeleteLoading"
      @hidemodal="dialogs.deleteDialog = false"
      @confirm="deleteAction()"
    />

    <view-purchase :viewDialog="dialogs.viewDialog" @hidemodal="dialogs.viewDialog = false" />

    <return-purchase
      :returnDialog="dialogs.returnDialog"
      @hidemodal="dialogs.returnDialog = false"
      @returned="updateDatatableResult(), (dialogs.returnDialog = false), (allowGettingData = false), goToReturn()"
    />

    <add-single-payment
      :paymentDialog="dialogs.paymentDialog"
      :statement="statement"
      :account="accountPayableInfo"
      @reset-datatable="resetDataTable(), showPayments()"
      @hidemodal="resetAllErrors(true), (dialogs.paymentDialog = false)"
    />

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />

    <add-supplier
      :addDialog="dialogs.addSupplier"
      @reset-datatable="setVendersList()"
      @hidemodal="resetAllErrors(true), (dialogs.addSupplier = false)"
    />

    <add-product
      :addDialog="dialogs.addProduct"
      @reset-datatable="setPurchaseProductsList()"
      @hidemodal="resetAllErrors(true), (dialogs.addProduct = false)"
      @add-product-type="dialogs.addProductType = true"
    />

    <add-product-type
      :addDialog="dialogs.addProductType"
      @reset-datatable="updateFullProductTypesList()"
      @hidemodal="resetAllErrors(true), (dialogs.addProductType = false)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    dtSearchBox: () => import('@/views/_partials/AppSearchBox.vue'),
    dtPagination: () => import('@/views/_partials/AppDatatablePagination.vue'),
    addPurchase: () => import('./addPurchase.vue'),
    editPurchase: () => import('./editPurchase.vue'),
    viewPurchase: () => import('./viewPurchase.vue'),
    returnPurchase: () => import('./returnPurchase.vue'),
    addSinglePayment: () => import('@/views/accounting/accountPayable/statements/addSinglePayment.vue'),
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue'),
    addSupplier: () => import('@/views/suppliers/addSupplier.vue'),
    addProduct: () => import('@/views/inventory/products/addProduct.vue'),
    addProductType: () => import('@/views/inventory/productTypes/addProductType.vue')
  },

  data() {
    return {
      dialogs: {
        viewDialog: false,
        addDialog: false,
        editDialog: false,
        deleteDialog: false,
        returnDialog: false,
        paymentDialog: false,
        printExportDialog: false,
        addSupplier: false,
        addProduct: false,
        addProductType: false
      },
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      deleteId: 0,
      btnDeleteLoading: false,
      isDatatable: true,
      search: null,
      oldSearch: null,
      loading: false,
      defaultSortBy: 'purchase_id',
      perPageNumber: 10,
      pagination: {
        sortBy: this.defaultSortBy,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 1
      },
      oldPagination: {},
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'purchase_id',
        //   align: 'left',
        //   sortable: true
        // },
        { text: this.$t('Bill Number'), value: 'bill_auto_number' },
        {
          text: this.$t('Supplier Invoice Number'),
          value: 'supplier_invoice_number'
        },
        { text: this.$t('Supplier'), value: 'vender_name' },
        {
          text: `${this.$t('Grand Total')} (${localStorage.systemCurrency})`,
          value: 'total_amount'
        },
        { text: this.$t('Bill Date'), value: 'bill_date' },
        { text: this.$t('Payment Type'), value: 'cash_or_opening_balance' },
        { text: this.$t('Bill Status'), value: 'bill_status' },
        { text: this.$t('Payment Status'), value: 'payment_status' }
      ],
      allowGettingData: true,
      accountPayableInfo: {},
      statement: {}
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Purchases'),
      icon: 'attach_money'
    })

    this.setPurchaseProductsList()
    this.setVendersList()
    this.updateFullProductTypesList()

    if (this.hasActionsMenuPermissions()) {
      this.headers.push({
        text: this.$t('datatable-actions'),
        value: '',
        sortable: false,
        class: 'myClass'
      })

      // setTimeout(() => {
      //   Object.assign(document.querySelector('.myClass').style, {
      //     position: 'sticky',
      //     right: 0,
      //     backgroundColor: 'white',
      //     webkitBoxShadow: '4px 10px 10px 1px #bbbbbb',
      //     mozBoxShadow: '4px 10px 10px 1px #bbbbbb',
      //     boxShadow: '4px 10px 10px 1px #bbbbbb'
      //   })
      // }, 1000)
    }
  },

  computed: {
    ...mapGetters({
      resultData: 'purchases/getPurchaseList'
    })
  },

  watch: {
    pagination: {
      immediate: false,
      deep: false,
      handler() {
        let p = this.pagination
        let op = this.oldPagination
        if (p.sortBy !== op.sortBy || p.descending !== op.descending) {
          op.sortBy = p.sortBy
          op.descending = p.descending
          p.page = 1
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        } else if (this.allowGettingData || this.search !== this.oldSearch) {
          this.oldSearch = this.search
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        }
      }
    }
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'purchases/updatePurchaseList',
      deleteRecord: 'purchases/deletePurchase',
      fetchPurchaseInfo: 'purchases/fetchPurchaseInfo',
      fetchStatementInfo: 'accountStatements/fetchStatementInfo',
      closePurchase: 'purchases/closePurchase',
      openPurchase: 'purchases/openPurchase',
      setPurchaseProductsList: 'products/setFullPurchaseProductsList',
      setVendersList: 'suppliers/setFullVendersList',
      updateFullProductTypesList: 'productTypes/updateFullProductTypesList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    hasActionsMenuPermissions() {
      return helpers.userHasPermissions([
        'purchases_show',
        'purchases_update',
        'purchases_destroy',
        'purchases_unclose',
        'purchases_close',
        'single_statement_payment_store'
      ])
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      if (clickedButton === 'print') {
        this.loadThePrintBtn = true
      } else if (clickedButton === 'export') {
        this.loadTheExportBtn = true
      }
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== 'Actions' && f.text !== 'الاجراءات')

      Axios.get('purchases_index', {
        params: { is_paginated: 0, search: this.search }
      })
        .then(response => {
          this.tableBody = response.data.data
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = true
        })
        .catch(() => {
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = false
        })
    },

    updateDatatableResult() {
      this.loading = true
      let payload = {
        ...this.pagination,
        search: this.search
      }
      this.updateResult(payload)
        .then(() => {
          this.pagination.page = this.resultData.current_page
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetDataTable() {
      this.allowGettingData = true

      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: this.perPageNumber,
        totalItems: 1
      }
      this.search = this.oldSearch = null
    },

    resultsPerPageChanged(val) {
      this.perPageNumber = val
      this.pagination.rowsPerPage = val
      this.pagination.page = 1
      this.updateDatatableResult()
    },

    pageChanged(val) {
      this.pagination.page = val
      this.updateDatatableResult()
    },

    searchValue(val) {
      this.search = val
    },

    viewRecord(id) {
      this.fetchPurchaseInfo(id).then(() => {
        this.dialogs.viewDialog = true
      })
    },

    editRecord(id) {
      this.fetchPurchaseInfo(id).then(() => {
        this.dialogs.editDialog = true
      })
    },

    showConfirmDeletion(id) {
      this.deleteId = id
      this.dialogs.deleteDialog = true
    },

    deleteAction() {
      this.btnDeleteLoading = true
      this.deleteRecord(this.deleteId)
        .then(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
          let payload = {
            ...this.pagination,
            search: this.search
          }
          this.updateResult(payload)
        })
        .catch(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
        })
    },

    closePurchaseRecord(item) {
      const payload = {
        id: item.purchase_id,
        cash_or_opening_balance: item.cash_or_opening_balance
      }
      this.closePurchase(payload)
        .then(() => {
          let payload = {
            ...this.pagination,
            search: this.search
          }
          this.updateResult(payload)
        })
        .catch(() => {})
    },

    openPurchaseRecord(id) {
      this.openPurchase(id).then(() => {
        let payload = {
          ...this.pagination,
          search: this.search
        }
        this.updateResult(payload)
      })
    },

    returnPurchaseRecord(id) {
      this.fetchPurchaseInfo(id).then(() => {
        this.dialogs.returnDialog = true
      })
    },

    singlePayment(item) {
      this.fetchStatementInfo(item.payable_statement_id).then(() => {
        this.statement = {
          payable_statement_id: item.payable_statement_id,
          amount: item.total_amount
        }
        this.accountPayableInfo = {
          account_payable_id: item.account_payable_id,
          total_debit: item.total_debit,
          total_balance: item.total_balance,
          total_credit: item.total_credit,
          vender_name: item.vender_name
        }

        this.dialogs.paymentDialog = true
      })
    },

    goToReturn() {
      this.$router.push({ name: 'accounting-purchases-returns' })
    },

    showPayments() {
      this.$router.push({
        name: 'accounting-account-payable-payments',
        query: {
          account_payable_id: this.accountPayableInfo.account_payable_id,
          name: this.accountPayableInfo.vender_name,
          commission: false
        }
      })
    }
  }
}
</script>

<style scoped />
